import React, { useState, useEffect } from "react";
import Logo from "../../assets/Anell.png";
import { FaBars, FaChevronDown, FaChevronUp } from "react-icons/fa6";
import { FaTimes } from "react-icons/fa";
import NavItem from "../NavItem/NavItem";
import { Link } from "react-router-dom";

const Navbar = () => {
    const [mobileView, setMobileView] = useState(false);
    const [expandedMenus, setExpandedMenus] = useState({});

    const toggleSubmenu = (menuName) => {
        setExpandedMenus(prev => ({
            ...prev,
            [menuName]: !prev[menuName]
        }));
    };

    useEffect(() => {
        if (mobileView) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [mobileView]);

    const NavItemsData = [
        {
            path: "/",
            name: "Home"
        },
        {
            path: "/about",
            name: "About",
            submenus: [
                {
                    path: "/about/overview",
                    name: "Overview"
                },
                {
                    path: "/about/message-from-head",
                    name: "Message from leadership"
                },
                {
                    path: "/schools",
                    name: "Schools",
                    submenus: [
                        {
                            path: "/schools/preschool",
                            name: "Pre-School"
                        },
                        {
                            path: "/schools/elementary",
                            name: "The Elementary School"
                        },
                        {
                            path: "/schools/lower-secondary",
                            name: "Lower Secondary"
                        },
                        
                    ]
                },
                {
                    path: "/about/departments",
                    name: "Departments"
                },
                {
                    path: "/about/careers",
                    name: "Careers"
                },
                {
                    path: "/about/faq",
                    name: "FAQ"
                },
            ]
        },
        {
            path: "/admission",
            name: "Admission"
        },
        {
            path: "/anell-360",
            name: "Anell 360",
            submenus: [
                {
                    path: "/schools",
                    name: "Student Experience",
                    submenus: [
                        {
                            path: "/schools/student-life",
                            name: "Student Life"
                        },
                        {
                            path: "/schools/clubs-teams",
                            name: "Clubs & Teams System"
                        },
                        {
                            path: "/schools/extra-curricular",
                            name: "Extra-Curricular Activities"
                        },
                        {
                            path: "/schools/signature-events",
                            name: "Signature Events & School Engagements"
                        },
                        
                    ]
                },
                {
                    path: "/anell-360/staff-life",
                    name: "Staff Life & Professional Culture",
                }
            ]
        },
        {
        path:"/news-events",
        name:"News & Events",
        submenus:[
          {
            path:"/news-events/news",
            name:"News",
          },
          {
            path:"/news-events/calendar",
            name:"Calendar",
          }
        ]
      },
        {
            path: "/contact-us",
            name: "Contact Us"
        },
        {
            path: "/login",
            name: "Portal",
            isButton: true
        }
    ];

    return (
        <nav className="sticky top-0 z-[1000] w-full bg-white shadow-md">
            <div className="mx-auto flex items-center justify-between px-5 md:px-10 lg:px-20 h-24 lg:h-32">
                {/* Logo Section */}
                <Link to="/" className="flex items-center gap-3">
                    <img src={Logo} alt="anell school of excellence" className="h-12 w-auto md:h-16 lg:h-20" />
                    <div className="flex flex-col">
                        <div className="flex items-center gap-1.5">
                            <h2 className="text-3xl font-bold text-[#021d53] md:text-4xl lg:text-5xl">Anell</h2>
                            <div className="flex flex-col text-[8px] font-semibold leading-tight text-[#221b2d] md:text-sm">
                                <span>SCHOOL OF</span>
                                <span>EXCELLENCE</span>
                            </div>
                        </div>
                        <p className="text-[10px] italic font-semibold text-[#021d53] md:text-sm lg:text-base">
                            ...excel and lead!!!
                        </p>
                    </div>
                </Link>

                {/* Desktop Navigation */}
                <div className="hidden xl:flex items-center h-full">
                    <ul className="flex items-center gap-8 h-full">
                        {NavItemsData.map((item, index) => (
                            <NavItem item={item} key={index} />
                        ))}
                    </ul>
                </div>

                {/* Mobile Menu Toggle */}
                <div className="xl:hidden text-2xl text-[#021d53] cursor-pointer" onClick={() => setMobileView(!mobileView)}>
                    {mobileView ? <FaTimes /> : <FaBars />}
                </div>
            </div>

            {/* Mobile Sidebar Overlay */}
            <div 
                className={`fixed inset-0 z-[1001] bg-black/50 transition-opacity duration-300 xl:hidden ${mobileView ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
                onClick={() => setMobileView(false)}
            />

            {/* Mobile Sidebar */}
            <div 
                className={`fixed top-0 right-0 z-[1002] h-full w-[280px] bg-[#1f1f1f] shadow-2xl transition-transform duration-300 ease-in-out xl:hidden ${mobileView ? 'translate-x-0' : 'translate-x-full'}`}
            >
                <div className="flex justify-end p-6">
                    <FaTimes className="text-2xl text-white cursor-pointer" onClick={() => setMobileView(false)} />
                </div>
                <div className="px-6 py-4">
                    <ul className="flex flex-col gap-4">
                        {NavItemsData.map((item, index) => (
                            <li key={index} className="border-b border-gray-700 pb-2">
                                {item.submenus ? (
                                    <div className="flex flex-col gap-2">
                                        <div 
                                            className="flex items-center justify-between cursor-pointer py-1"
                                            onClick={() => toggleSubmenu(item.name)}
                                        >
                                            <span className="text-sm font-bold uppercase tracking-wider text-gray-400">{item.name}</span>
                                            {expandedMenus[item.name] ? <FaChevronUp className="text-xs text-gray-400" /> : <FaChevronDown className="text-xs text-gray-400" />}
                                        </div>
                                        {expandedMenus[item.name] && (
                                            <ul className="ml-4 flex flex-col gap-2 border-l border-gray-700 pl-4 mt-1">
                                                {item.submenus.map((sub, idx) => (
                                                    <li key={idx}>
                                                        {sub.submenus ? (
                                                            <div className="flex flex-col gap-2">
                                                                <div 
                                                                    className="flex items-center justify-between cursor-pointer py-1"
                                                                    onClick={() => toggleSubmenu(sub.name)}
                                                                >
                                                                    <span className="text-gray-300 hover:text-white transition-colors">{sub.name}</span>
                                                                    {expandedMenus[sub.name] ? <FaChevronUp className="text-[10px] text-gray-500" /> : <FaChevronDown className="text-[10px] text-gray-500" />}
                                                                </div>
                                                                {expandedMenus[sub.name] && (
                                                                    <ul className="ml-4 mt-1 flex flex-col gap-2 border-l border-gray-600 pl-3">
                                                                        {sub.submenus.map((innerSub, innerIdx) => (
                                                                            <li key={innerIdx}>
                                                                                <Link to={innerSub.path} className="text-gray-400 hover:text-white text-sm" onClick={() => setMobileView(false)}>
                                                                                    {innerSub.name}
                                                                                </Link>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                )}
                                                            </div>
                                                        ) : (
                                                            <Link to={sub.path} className="text-gray-300 hover:text-white transition-colors block py-1" onClick={() => setMobileView(false)}>
                                                                {sub.name}
                                                            </Link>
                                                        )}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                ) : (
                                    <Link 
                                        to={item.path} 
                                        className="text-lg font-bold text-gray-300 hover:text-white"
                                        onClick={() => setMobileView(false)}
                                    >
                                        {item.name}
                                    </Link>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
